import React from 'react';
import { XCircleIcon, CheckCircle2Icon } from 'lucide-react';
export function ManualComparison() {
  const comparisons = [{
    situation: 'Pagás Netflix, Spotify y Adobe con tarjeta',
    without: 'Perdés el 35-45% en percepciones',
    with: 'Sabés cómo recuperarlo paso a paso'
  }, {
    situation: 'Te retuvieron SIRCREB en el banco',
    without: 'No sabés cómo pedirlo de vuelta',
    with: 'Tramitás la exclusión en 30 minutos'
  }, {
    situation: 'Tenés gastos deducibles de Ganancias',
    without: 'Los regalás porque no los cargaste',
    with: 'Pagás menos impuesto cada mes'
  }, {
    situation: 'Saldo a favor en AFIP de años anteriores',
    without: 'Prescribe y lo perdés para siempre',
    with: 'Lo reclamás y te depositan en tu CBU'
  }];
  return <section className="py-16 px-4 sm:px-6 lg:px-8" data-id="element-107">
      <div className="max-w-6xl mx-auto" data-id="element-108">
        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12 text-[#1A1A1A]" data-id="element-109">
          🚀 ¿QUÉ AGREGA EL MANUAL DEL REINTEGRO?
        </h2>

        <div className="overflow-x-auto bg-white rounded-lg shadow-sm border border-[#EAE5DC]" data-id="element-110">
          <table className="w-full border-collapse" data-id="element-111">
            <thead data-id="element-112">
              <tr className="border-b-2 border-[#EAE5DC]" data-id="element-113">
                <th className="text-left p-4 font-bold text-[#1A1A1A] bg-[#FAF7F2]" data-id="element-114">
                  Situación
                </th>
                <th className="text-left p-4 font-bold text-[#E85D5D] bg-[#E85D5D]/10" data-id="element-115">
                  ❌ Sin Manual
                </th>
                <th className="text-left p-4 font-bold text-[#5BB4A0] bg-[#5BB4A0]/10" data-id="element-116">
                  ✅ Con Manual
                </th>
              </tr>
            </thead>
            <tbody data-id="element-117">
              {comparisons.map((row, index) => <tr key={index} className="border-b border-[#EAE5DC] hover:bg-[#FAF7F2] transition-colors" data-id="element-118">
                  <td className="p-4 text-[#1A1A1A] font-medium" data-id="element-119">
                    {row.situation}
                  </td>
                  <td className="p-4 bg-[#E85D5D]/5" data-id="element-120">
                    <div className="flex items-start gap-2" data-id="element-121">
                      <XCircleIcon className="w-5 h-5 text-[#E85D5D] flex-shrink-0 mt-0.5" data-id="element-122" />
                      <span className="text-[#1A1A1A]" data-id="element-123">{row.without}</span>
                    </div>
                  </td>
                  <td className="p-4 bg-[#5BB4A0]/5" data-id="element-124">
                    <div className="flex items-start gap-2" data-id="element-125">
                      <CheckCircle2Icon className="w-5 h-5 text-[#5BB4A0] flex-shrink-0 mt-0.5" data-id="element-126" />
                      <span className="text-[#1A1A1A]" data-id="element-127">{row.with}</span>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}